/*!
* @nutui/nutui v3.3.6 Fri Mar 10 2023 14:47:39 GMT+0800 (中国标准时间)
* (c) 2022 @jdf2e.
* Released under the MIT License.
*/
import { reactive, ref } from "vue";
import Lang from "./zh-CN.js";
import Lang$1 from "./en-US.js";
import "./baseLang.js";
const isObject = (val) => val !== null && typeof val === "object";
const deepMerge = (target, newObj) => {
  Object.keys(newObj).forEach((key) => {
    let targetValue = target[key];
    let newObjValue = newObj[key];
    if (isObject(targetValue) && isObject(newObjValue)) {
      deepMerge(targetValue, newObjValue);
    } else {
      target[key] = newObjValue;
    }
  });
  return target;
};
const langs = reactive({
  "zh-CN": new Lang(),
  "en-US": new Lang$1()
});
class Locale {
  static languages() {
    return langs[this.currentLang.value];
  }
  static use(lang, newLanguages) {
    if (newLanguages) {
      langs[lang] = new newLanguages();
    }
    this.currentLang.value = lang;
  }
  static merge(lang, newLanguages) {
    if (newLanguages) {
      if (langs[lang]) {
        deepMerge(langs[lang], newLanguages);
      } else {
        this.use(lang, newLanguages);
      }
    }
  }
}
Locale.currentLang = ref("zh-CN");
export { Locale, Locale as default };
